import { Action, ArgumentAction, ArgumentState, OfferState } from "./types";

const OfferReducer = (state: OfferState, action: Action) => {
    switch (action.type) {
        case 'SET_CLASSIFICATION':
            return { ...state, classificationId: action.payload };
        case 'SET_AC':
            return { ...state, acId: action.payload };
        case 'SET_PLAY':
            return { ...state, playId: action.payload };
        case 'SET_TYPE':
            return { ...state, typeId: action.payload };
        case 'SET_INTERNETPLAN':
            return { ...state, internetPlanId: action.payload };
        case 'SET_MOBILEPLAN':
            return { ...state, mobilePlanId: action.payload };
        case 'SET_VIDEOPLAN':
            return { ...state, videoPlanId: action.payload };
        case 'SET_INTERNETPLANPROMO':
            return { ...state, internetPlanPromoId: action.payload };
        case 'SET_INTERNETPLANPROMODURATION':
            return { ...state, internetPlanPromoDuration: action.payload };
        case 'SET_ADVANCEPAYMENTPROMO':
            return { ...state, advancePaymentPromo: action.payload };
        case 'SET_CHANNELAPPS':
            return { ...state, channelsApps: action.payload };
        case 'SET_PERMANENTPROMO':
            return { ...state, permanentPromo: action.payload };
        case 'SET_PRICE':
            return { ...state, price: action.payload };
        case 'SET_PROMOPRICE':
            return { ...state, promoPrice: action.payload };
        case 'SET_PROMOPRICEDURATION':
            return { ...state, promoPriceDuration: action.payload };
        case 'SET_ADDMOBILEPROMO':
            return { ...state, addMobilePromo: action.payload };
        case 'SET_ADDMOBILEPROMODURATION':
            return { ...state, addMobilePromoDuration: action.payload };
        case 'SET_ARGUMENTS':
            return { ...state, arguments: action.payload };
        case 'SET_EXPIRATIONDATE':
            return { ...state, expirationDate: action.payload };
        case 'SET_STATE':
            return { ...action.payload }; // Fully replace the state
        default:
            return state;
    }
}

export const ArgumentReducer = (state: ArgumentState, action: ArgumentAction) => {
    switch (action.type) {
        case 'SET_COMPETITOR':
            return { ...state, competitorId: action.payload };
        case 'SET_PLAN':
            return { ...state, plan: action.payload };
        case 'SET_COMPETITORPRICE':
            return { ...state, competitorPrice: action.payload };
        case 'SET_COMPETITORPROMOPRICE':
            return { ...state, competitorPromoPrice: action.payload };
        case 'SET_PROMOS':
            return { ...state, promos: action.payload };
        case 'SET_DESCRIPTION':
            return { ...state, description: action.payload };
        case 'SET_STATE':
            return { ...action.payload };
        default:
            return state;
    }
}

export default OfferReducer;